import i18n from 'services/base/i18n';

export default {
  domain: () => i18n.pgettext('Pages|List Issues|View Issue|Malware Domain', 'Malware Domain'),
  host:   () => i18n.pgettext('Pages|List Issues|View Issue|Malware Domain', 'Affected Host'),
  family: () => i18n.pgettext('Pages|List Issues|View Issue|Malware Domain', 'Malware Family'),
  action: () => i18n.pgettext('Pages|List Issues|View Issue|Malware Domain', 'Enforced Action'),
};
